import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAgentBehaviour } from '@obvious.tech/constellation'

export const AgentBehaviour = defineEntity('AgentBehaviour', {
  endpoint: 'simulator/api/AgentBehaviour',
  schema: SNoop<IAgentBehaviour>(),
})
